import React, { useState } from 'react'

import { Button, Avatar } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'
// Shared user-data fetch (avatar + username + logout); also used by LegacyNavigation.
import { useUserData } from 'Pods/UnifiedNavigation/Hooks/useUserData'

import { useUserMenu } from './Hooks/useUserMenu'

// UserInfoMenu is only needed once a signed-in user opens the menu, so it is
// lazy-loaded on first hover/click (mirrors the cart/inbox widget loading pattern).
let UserInfoMenu

function UserMenu({ isCurrentUser = false, locale = 'en', newRoyaltyUi = false }) {
  const { userData, handleLogout } = useUserData(isCurrentUser)
  const { isOpen, setIsOpen, wrapperRef } = useUserMenu()

  const [isUserInfoMenuLoaded, setIsUserInfoMenuLoaded] = useState(false)

  const isLoaded = isUserInfoMenuLoaded && !!UserInfoMenu

  function loadUserInfoMenu(callback) {
    if (!UserInfoMenu && !isUserInfoMenuLoaded) {
      import('Pods/LazyLoaded/UserInfoMenu/UserInfoMenu')
        .then((module) => {
          UserInfoMenu = module.default
          setIsUserInfoMenuLoaded(true)
          callback?.()
        })
        .catch((error) => {
          console.error('Failed to load UserInfoMenu:', error)
        })
    } else {
      callback?.()
    }
  }

  function handleToggle() {
    if (isOpen) {
      setIsOpen(false)
      return
    }

    if (isLoaded) {
      setIsOpen(true)
    } else {
      loadUserInfoMenu(() => setIsOpen(true))
    }
  }

  function handleMouseEnter() {
    if (!isLoaded) {
      loadUserInfoMenu()
    }
  }

  if (!isCurrentUser) {
    return (
      <div className="unified-nav__user">
        <Button type="secondary" size="small" href="/users/login">
          {i18n.t('navigation.user.login', { ns: 'rails', lng: locale })}
        </Button>
        <Button size="small" href="/users/registration">
          {i18n.t('navigation.user.register', { ns: 'rails', lng: locale })}
        </Button>
      </div>
    )
  }

  return (
    <div className="unified-nav__user" ref={wrapperRef}>
      <button
        type="button"
        className="unified-nav__user-avatar"
        aria-haspopup="menu"
        aria-expanded={isOpen}
        aria-label={userData?.attributes?.username || 'Account'}
        onClick={handleToggle}
        onMouseEnter={handleMouseEnter}
      >
        <Avatar
          size="32"
          username={userData?.attributes?.username}
          img={userData?.attributes?.avatar?.large_url}
          useSingleLetter
        />
      </button>

      {isOpen && isLoaded && (
        <UserInfoMenu
          userData={userData}
          locale={locale}
          handleLogout={handleLogout}
          newRoyaltyUi={newRoyaltyUi}
        />
      )}
    </div>
  )
}

UserMenu.propTypes = {
  isCurrentUser: bool,
  locale: string,
  newRoyaltyUi: bool,
}

export default UserMenu
